{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Izbirnik barv",
  "twoDimensionalSlider": "2D drsnik",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
